module.exports = __webpack_public_path__ + "static/media/user-group.c4643c44.svg";